export default class CancelEventException extends Error {
	constructor(message) {
		super();
		this.name = 'CancelEventException';
		this.message = message;
		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, CancelEventException);
		} else {
			this.stack = (new Error(message)).stack;
		}
	}
};
